var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 1C8.61116 1 1 8.61116 1 18C1 27.3888 8.61116 35 18 35C27.3888 35 35 27.3888 35 18C35 8.61116 27.3888 1 18 1Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 1C8.61116 1 1 8.61116 1 18C1 27.3888 8.61116 35 18 35C27.3888 35 35 27.3888 35 18C35 8.61116 27.3888 1 18 1Z",
    stroke: "#1E2329",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1095_14473)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 11.25C21.4142 11.25 21.75 11.7079 21.75 12.2727V21.4773C21.75 22.0421 21.4142 22.5 21 22.5C20.5858 22.5 20.25 22.0421 20.25 21.4773V12.2727C20.25 11.7079 20.5858 11.25 21 11.25Z",
    fill: "#16191E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2197 22.2803L20.4697 24.5303C20.7626 24.8232 21.2375 24.8232 21.5304 24.5303L23.7804 22.2803C23.9949 22.0658 24.059 21.7432 23.9429 21.463C23.8268 21.1827 23.5534 21 23.25 21H18.75C18.4467 21 18.1732 21.1827 18.0571 21.463C17.941 21.7432 18.0052 22.0658 18.2197 22.2803Z",
    fill: "#16191E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 13.5C15.4142 13.5 15.75 13.9579 15.75 14.5227V23.7273C15.75 24.2921 15.4142 24.75 15 24.75C14.5858 24.75 14.25 24.2921 14.25 23.7273V14.5227C14.25 13.9579 14.5858 13.5 15 13.5Z",
    fill: "#16191E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5304 11.4697C15.2375 11.1768 14.7626 11.1768 14.4697 11.4697L12.2197 13.7197C12.0052 13.9342 11.941 14.2568 12.0571 14.537C12.1732 14.8173 12.4467 15 12.75 15H17.25C17.5534 15 17.8268 14.8173 17.9429 14.537C18.059 14.2568 17.9949 13.9342 17.7804 13.7197L15.5304 11.4697Z",
    fill: "#16191E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1095_14473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.7163b92bc7144826911f1c20f15d962b.svg";
export { ForwardRef as ReactComponent };